import {  Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SearchTitleInput = ({ children, id, title }: { children: any, id: any, title: string }) => {
  const { t } = useTranslation()


  return (
    <Grid container spacing={1} key={id}>
      <Grid item xs={12}>
        <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#707070', }}>{title}</Typography>
      </Grid>

      <Grid item xs={12}>{children}</Grid>

    </Grid>
  )
}
